import React, { useEffect } from "react";
import { Exercise } from "../../../models/Exercise";
import useCalendarSale from "../../ThreeStep/hooks/useCalendarSale";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { MODAL_TEST } from "../../../routes";
import { setExerciseName, setExerciseZoneId } from "../../../store/pseudoModal/pseudoModalsActions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { State } from "../../../store";
import EAProductBanner from "../../shared/ProductBanner/EAProductBanner";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";

interface IProps {
  exercise: Exercise;
}

const SingleAvailAbleExercise: React.FC<IProps> = ({ exercise }: IProps) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();
  const ids = useSelector((state: State) => state.config.facilityIds);
  const navigate = useNavigate();
  const { getTicketsByExercise, tickets } = useCalendarSale();
  useEffect(() => {
    getTicketsByExercise(exercise.exerciseGroup, exercise);
    //eslint-disable-next-line
  }, []);
  const dispatch = useDispatch();
  const lowestPrice = tickets
    .filter((ticket) => ticket.price > 0)
    .reduce((r, b) => Math.min(r, b.price), Number.POSITIVE_INFINITY);

  const updateState = () => {
    navigate(
      `${MODAL_TEST}?id=${ids}&exerciseName=${exercise.name.replace(/%/g, "%25")}&exerciseIds=${exercise.zone.objectId}`
    );
    dispatch(setExerciseName(exercise.name));
    dispatch(setExerciseZoneId(exercise.zone.objectId));
    window.parent.postMessage("scroll::", "*");
  };

  return (
    <EAProductBanner
      title={exercise.name}
      pictureUrl={exercise.eventMessage}
      description={exercise.description}
      mainPrice={isDesktop ? `${t("ceny_od")} ${lowestPrice}` : `${t("od")} ${lowestPrice}`}
      buttonTitle={t("wybierz")}
      onClick={() => updateState()}
    />
  );
};

export default SingleAvailAbleExercise;
